<ngx-spinner name="spinner-with-message" bdColor="rgba(15,15,31,0.9)" size="medium" color="#ef870a" type="ball-spin-clockwise" [fullScreen]="true"><p style="color: white" > Unlocking your path to achievement… </p></ngx-spinner>
<ngx-spinner type="ball-spin-clockwise" bdColor="rgba(15,15,31,0.9)" size="medium" color="#ef870a" [fullScreen]="true"></ngx-spinner>


<div class="header-container">

    <div id="layoutHome" class="web-center fm-rubik" *ngIf="cart.length==0">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;" [style]="!isMobile ? 'margin-top: 100px;' : 'margin-top: 50px;margin-bottom:40px;'">
            <i class="pi pi-shopping-cart fs08 arrow-icon mb-4" style="font-size: 40px;"></i>
            <span class="font-empty">Your cart is empty.</span>
            <span class="font-empty">Please go to plan</span><br>
            <app-orange-button (action)="goToOrderFlow()"></app-orange-button>
        </div>
    </div>


    <div id="layoutHome" class="fm-rubik" *ngIf="cart.length > 0">
        <div id="checkout-container">
            <div class="checkout-flex-container">
                <div class="checkout-box">
                    <ng-container *ngTemplateOutlet="checkoutProcess"></ng-container>
                    <app-disclaimer></app-disclaimer>
                </div>
                <div class="checkout-box" id="order-summary-box">
                    <ng-container *ngTemplateOutlet="orderSummary"></ng-container> 
                </div>
            </div>
    </div>
</div>

<ng-template #myBasket>
        <div class="basket-container">
            <div class="card-body m-3">
                <p-divider></p-divider>
                <div  *ngIf="cart[currWeek-1].length>0">
                    <div *ngFor="let item of cart[currWeek-1]" >
                        <span class="fm-rubik meal-item-count">{{item.count}} x </span>
                        <span class="fm-rubik meal-item-text">{{item.name}}</span>
                    </div>
                </div>
            </div>
        </div>
</ng-template>


<ng-template #checkoutProcess>
    <div>
    <p-tabMenu [model]="items" [activeItem]="activeItem" (activeItemChange)="onActiveItemChange($event)" styleClass="payment-menu" class="mb-1"></p-tabMenu>
    <div id="checkout-box-content">
        <form novalidate (ngSubmit)="createToken()" [formGroup]="stripeTest">
            <div class="row mb-4" *ngIf="activeItem == items[0]">
                <div class="col-md-12" style="display: flex; align-items: flex-start; flex-direction: column;">
                    <span style="font-size: 0.857rem;color: #0F0F1F;font-weight: 500;" class="mb-1">Full Name: </span>
                    <input type="text" formControlName="name" class="p-2 input-promo" placeholder="Full Name" style="width: 100%; height: 43px;">
                </div>
            </div>
        </form>
        <div class="row mb-4" *ngIf="activeItem == items[0]">
            <div class="col-md-12" style="display: flex; align-items: flex-start; flex-direction: column;">
                <span style="font-size: 0.857rem;color: #0F0F1F;font-weight: 500;" class="mb-1">Phone Number: </span>
                <div style="display: flex; width: 100%; height: 43px;">
                    <p-dropdown [options]="phonePrefixes" optionLabel="label" optionValue="value" [(ngModel)]="phonePrefix" 
                                placeholder="+44" [style]="{'width': '130px', 'margin-right': '8px', 'height': '43px'}" 
                                styleClass="phone-prefix-dropdown"></p-dropdown>
                    <input type="text" class="p-2 input-promo" placeholder="Phone Number" 
                            style="flex: 1; height: 43px;" [(ngModel)]="phone_number" 
                            (input)="validatePhoneNumber($event)" maxlength="15">
                </div>
            </div>
        </div>
        <app-address-search *ngIf="activeItem == items[0]" [searchType]="addressSearchType" (addressSelected)="onAddressSelected($event)"></app-address-search>
        <div style="margin-top: 20px; margin-bottom: 30px !important" *ngIf="activeItem == items[1]">
            <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                <ngx-stripe-payment [options]="paymentElementOptions" *ngIf="elementsOptions.clientSecret"/>
            </ngx-stripe-elements>
        </div>
        
    
        <!-- Buttons -->
        <div style="display: flex; justify-content: flex-end; align-items: center; margin-bottom: 30px !important;">
            
            <div style="display: flex; gap: 16px;">
                
                <button class="btn btn-primary mt-2 weight-500 btn-orderNow fm-prompt" style="font-size: 1.143rem;" (click)="pay()" *ngIf="activeItem == items[1]">Pay
                    <i class="pi pi-arrow-right text-white fs08 arrow-icon"></i>
                </button>
                
                <button class="btn btn-primary mt-2 weight-500 btn-orderNow fm-prompt" style="font-size: 1.143rem;" (click)="next()" *ngIf="activeItem == items[0]">Next
                    <i class="pi pi-arrow-right text-white fs08 arrow-icon"></i>
                </button>

                
            </div>
            
            
        </div>
            

    </div>
</div>

</ng-template>


<ng-template #orderSummary>
    
         <div class="order-summary-container">
            <div id="order-summary">
                <div>Order Summary</div>
            </div>
            
            <div style="margin-top: 35px">
                <!--
                <div style="display: flex; justify-content: space-between; align-items: baseline;">
                    <span class="order-summary-label">Plan</span>&nbsp;
                    <span class="order-summary-data">{{planOrderDetails.type}}</span>
                </div>
                -->
                <p-divider></p-divider>
                <div>
                    <span class="order-summary-label"><img src="assets/images/delivery-van-icon.svg"/>&nbsp;&nbsp;Total Deliveries</span>
                    <span class="order-summary-data">{{weeklyDeliveriesCount}}</span>
                </div>
                <p-divider></p-divider>
                <div style="display: flex; justify-content: space-between; align-items: baseline;">
                    <span class="order-summary-label">First delivery on</span>&nbsp;
                    <span class="order-summary-data">{{deliveryDate}}</span>
                </div>
                <p-divider></p-divider>
                <div style="display: flex; justify-content: space-between; align-items: baseline;">
                    <span class="order-summary-label">{{planOrderDetails.mealPerDay * planOrderDetails.dayPerWeek}} meals<i class="pi" [ngClass]="showMainCheckout ? 'pi-chevron-up' : 'pi-chevron-down'" style="cursor: pointer; margin-left: 8px;" (click)="showMainCheckout = !showMainCheckout"></i></span>&nbsp;
                    <span class="order-summary-data">£{{getWeekSubTotalPrice()}}</span>
                </div>
                <div *ngIf="showMainCheckout">
                    <ng-container *ngTemplateOutlet="myBasket"></ng-container>
                </div>
                
                <p-divider *ngIf="+discountVisual() > 0"></p-divider>
                <div *ngIf="+discountVisual() > 0">
                    <span class="order-summary-label">Discount <span id="discount-circle">{{discount}}% off</span></span>
                    <span class="order-summary-data">- £{{discountVisual()}}</span>
                </div>
                
                <p-divider></p-divider>
                <div>
                    <span class="order-summary-label">Delivery fee</span>
                    <span *ngIf="getDeliveryFeesFirstWeek() > 0" style="float: right;font-size: 0.857rem;color: #5D5D66;">+ £{{getDeliveryFeesFirstWeek()}}</span>
                    <span *ngIf="getDeliveryFeesFirstWeek() == 0 && free_shipping_type == 'entire_order'" style="float: right;font-size: 0.857rem;color: #F8A94A;"><b>FREE</b></span>
                    <span *ngIf="getDeliveryFeesFirstWeek() == 0 && free_shipping_type == 'first_week'" style="float: right;font-size: 0.857rem;color: #F8A94A;"><b>1st week FREE</b></span>
                </div>
                <p-divider *ngIf="promo_discount_id"></p-divider>
                <ng-container *ngIf="promo_discount_id">
                    <span class="order-summary-promo-code-label">Promo code</span>
                    <div class="d-flex" style="position: relative;">
                        <input type="text" class="input-promo-discount" [(ngModel)]="promo_code" readonly />
                        <!-- <button class="btn weight-500 btn-apply" (click)="applyDiscount()">Apply</button> -->
                    </div>
                    <span *ngIf="promo_discount_object && promo_discount_object.discount.firstWeekDiscount" style="color: green;font-weight: 500;">{{promo_discount_object.discount.firstWeekDiscount + '% off + ' + promo_discount_object.discount.discount + '% + ' + promo_discount_object.discount.discount + '% + ' + promo_discount_object.discount.discount + '%'}}</span>
                </ng-container>
                <p-divider></p-divider>
                <div>
                    <span class="order-summary-total-price-label"><span *ngIf="planOrderDetails.type!='Flexi'">Week</span> Total</span>
                    <span class="order-summary-total-price-data"><del style="color: grey;font-weight: 400;font-style: italic;" *ngIf="promo_discount_id">£{{getWeekDefaultTotalPrice()}}</del><span> £{{getFirstWeekTotalPrice()}}</span></span>
                </div>
                <div>
                    <span ></span>
                    <span class="order-summary-total-price-data" style="color:green">£{{getDiscountedMealPrice()}} per serving<span *ngIf="promo_discount_id">*</span></span>
                    <span *ngIf="promo_discount_id">*Discount applies to subscription plans only</span>
                </div>
            </div>
        </div>     
        
</ng-template>



<p-dialog
        [draggable]="false"
        [resizable]="false"
        [closable]="false"
        [blockScroll]="true"
        [(visible)]="showOrderSuccessPopup"
        [styleClass]="!isMobile ? 'custom-dialog-addons' : 'custom-dialog-mobile-addons'"
        (onHide)="goToHome()">
    <ng-template pTemplate="header">
        <div class="mt-4 align-items-center justify-content-center w-100 text-center">
            <img src="assets/images/task-done.png" style="width: 43px;height: 43px;" alt="">
            <br>
            <br>
            <span class="fm-prompt weight-500" style="font-size: 1.429rem;color: #0F0F1F;">Order confirmed!</span>
        </div>
    </ng-template>
    <div class="mt-1 p-2 text-center">
        <span style="font-size: 14px; font-weight: 400;">
            Our chefs are fastening their aprons and getting straight to it. Your next 8 weeks of meals, prepared with meticulous care, are now being brought to life. Enjoy a fully flexible subscription, skip, pause, cancel or tailor your plan anytime from your account.
        </span>
    </div>
    <div class="mt-4 p-2 d-flex" style="text-align: center; flex-direction: column; align-items: center;">
        <button class="btn btn-orange-animation fm-prompt weight-500 mb-3" (click)="goToHome()"
                style="color: white;background-color: #EF870A;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;width: 40%;">
            Keep browsing our pages
        </button>
    </div>
</p-dialog>